import { Component, computed, inject, input, Signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  AvatarBorderType,
  AvatarComponent
} from '@app/shared/components/group-avatars/avatar/proffeo-avatar.component';
import { AvatarsGroupComponent } from '@app/shared/components/group-avatars/proffeo-group-avatars.component';
import { DialogService } from '@app/shared/services/shared/dialog.service';
import { AvatarSize } from '@app/shared/types/enums/avatar-size.enum';
import { GroupRole } from '@app/shared/types/enums/group-role.enum';
import { Group } from '@app/shared/types/models/group/group.model';
import { ProjectParticipant } from '@app/shared/types/models/project/project-participant';
import { User } from '@app/shared/types/models/user/user.model';

@Component({
  selector: 'proffeo-project-participant-item',
  imports: [MatIconModule, AvatarsGroupComponent, AvatarComponent],
  templateUrl: './project-participant-item.component.html'
})
export class ProjectParticipantItemComponent {
  private readonly dialogService: DialogService = inject(DialogService);

  protected readonly AvatarSize = AvatarSize;
  protected readonly AvatarBorderType = AvatarBorderType;
  protected groupAdmin: Signal<User> = computed(
    () =>
      this.participants()
        ?.find(groupUser => groupUser.role === GroupRole.ADMIN)
        ?.user() || undefined
  );
  protected users: Signal<User[]> = computed(
    () =>
      this.participants()
        ?.filter(user => user.role === GroupRole.NONE)
        .map(participant => participant.user()) ||
      []?.filter(user => user.role === GroupRole.NONE).map(participant => participant.user()) ||
      []
  );

  public group = input.required<Group>();
  public participants = input.required<ProjectParticipant[]>();

  protected selectGroupUsers(): void {
    const preselectedMappedUsers = (this.users()?.map(user => user) ?? []).concat(this.groupAdmin());
    const lockedUser = this.groupAdmin();
    this.dialogService.openSelectUsersAsProjectParticpantsDialog(preselectedMappedUsers, lockedUser, this.group());
  }
}
